import terminusSagaBottle from './terminus/bottle';
import spottingGroupSagaBottle from './spottingGroup/bottle';
import terminusDrilldownSagaBottle from './terminusDrilldown/bottle';
import spottingGroupDrilldownSagaBottle from './spottingGroupDrilldown/bottle';
import keyManagerSagaBottle from './keyManager/bottle';
import mediaBrowserSagaBottle from './mediaBrowser/bottle';
import userBottle from './users/bottle';

const {
  terminusFetchSaga,
  terminusLoadCurrentNameSaga,
  terminusStartAddingVocabularySaga,
  terminusAddVocabularySaga,
  terminusDeleteVocabularySaga,
  terminusDownloadSaga,
} = terminusSagaBottle().container;

const {
  spottingGroupFetchSaga,
  spottingGroupLoadCurrentNameSaga,
  spottingGroupAddGroupSaga,
  spottingGroupDeleteGroupSaga,
  spottingGroupStartEditingSaga,
  spottingGroupDownloadGroupCSVSaga,
} = spottingGroupSagaBottle().container;

const {
  terminusDrilldownLoadCurrentNameSaga,
  terminusDrilldownCloneTermsToEditingSaga,
  terminusDrilldownFetchSaga,
  terminusDrilldownTerminatorSaga,
  terminusDrilldownSaveSaga,
  terminusDrilldownSetEditingWeightSaga,
} = terminusDrilldownSagaBottle().container;

const {
  spottingGroupDrilldownLoadCurrentNameSaga,
  spottingGroupDrilldownEditingStartSaga,
  spottingGroupDrilldownFetchSaga,
  spottingGroupDrilldownTerminatorSaga,
  spottingGroupDrilldownSaveSaga,
} = spottingGroupDrilldownSagaBottle().container;

const {
  watchSessionSaga,
  watchAccessTokenSaga,
  profileToGrantsSaga,
  watchReloadKey,
  watchEphemeralKey,
  autoReloadEphemeral,
  checkExpiration,
} = userBottle().container;

const {
  keyManagerFetchSaga,
  keyManagerCreateKeySaga,
} = keyManagerSagaBottle().container;

const {
  mediaBrowserFetchListSaga,
  mediaBrowserFetchItemSaga,
} = mediaBrowserSagaBottle().container;

const sagas = [
  terminusFetchSaga,
  terminusLoadCurrentNameSaga,
  terminusStartAddingVocabularySaga,
  terminusDeleteVocabularySaga,
  terminusAddVocabularySaga,
  terminusDownloadSaga,

  terminusDrilldownCloneTermsToEditingSaga,
  terminusDrilldownFetchSaga,
  terminusDrilldownLoadCurrentNameSaga,
  terminusDrilldownTerminatorSaga,
  terminusDrilldownSaveSaga,
  terminusDrilldownSetEditingWeightSaga,

  spottingGroupFetchSaga,
  spottingGroupLoadCurrentNameSaga,
  spottingGroupAddGroupSaga,
  spottingGroupDeleteGroupSaga,
  spottingGroupStartEditingSaga,
  spottingGroupDownloadGroupCSVSaga,

  spottingGroupDrilldownLoadCurrentNameSaga,
  spottingGroupDrilldownEditingStartSaga,
  spottingGroupDrilldownFetchSaga,
  spottingGroupDrilldownTerminatorSaga,
  spottingGroupDrilldownSaveSaga,

  keyManagerFetchSaga,
  keyManagerCreateKeySaga,

  mediaBrowserFetchListSaga,
  mediaBrowserFetchItemSaga,

  watchSessionSaga,
  watchAccessTokenSaga,
  profileToGrantsSaga,
  watchReloadKey,
  watchEphemeralKey,
  checkExpiration,

  autoReloadEphemeral,
].filter(a => a);

export default sagas;
